import React, { useEffect } from "react";
import { UBAppModal } from "../../../Libraries";

const ImageModal = ({ header, body, footer }) => {
  const { toggleImageModal: handleClose, toggle, image } = body || {};

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (toggle) {
        if (event.key === 'Escape') {
          // Close the modal when the 'Escape' key is pressed
          handleClose()
        } else if (event.key === 'Enter') {
          footer?.length && footer[0]?.action?.(); // Trigger an action when the 'Enter' key is pressed
        }
      }
    };

    // Add the event listener when the modal is open
    if (toggle) {
      window.addEventListener('keydown', handleKeyDown);
    }

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [toggle]);

  return (
    <UBAppModal
      id="image_modal"
      handleClose={() => handleClose()}
      open={toggle}
      header={{
        ...header,
        handleClose: () => handleClose(),
        dont_show_cross_icon: true,
      }}
      footer={footer}

    >
      <div className="imageViewModalBox">
        <img src={image} alt="transaction" style={{ resizeMode: "cover" }} />
      </div>
    </UBAppModal>
  );
};

export default ImageModal;
